import { useEffect, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";

import { hideExportSuccessToasts } from "../helpers/exportFlow";
import { setIsActionPanelActivated } from "../store/action-creators";
import {
    selectIsPanelExportActive,
    selectMultipleRevealIsInProgress,
} from "../store/selectors";

function useActivePanelLifeCycle() {
    const dispatch = useDispatch();
    const isExportFlowActive = useSelector(selectIsPanelExportActive);
    const isMultipleRevealInProgress = useSelector(selectMultipleRevealIsInProgress);

    const isOperationInProgressRef = useRef(false);

    useEffect(() => {
        isOperationInProgressRef.current = isExportFlowActive || isMultipleRevealInProgress;
    }, [isExportFlowActive, isMultipleRevealInProgress]);

    useEffect(() => {
        const isRestoringActiveFlow = isExportFlowActive || isMultipleRevealInProgress;

        if (!isRestoringActiveFlow) {
            dispatch(hideExportSuccessToasts());
        }

        dispatch(setIsActionPanelActivated(true));

        return () => {
            if (!isOperationInProgressRef.current) {
                dispatch(setIsActionPanelActivated(false));
            }
        };
    }, []);
}

export default useActivePanelLifeCycle;
